<div class='SelectUsersWizardStep'>
  <div *ngIf='singleSelection' class='alert alert-warning'>
    <p class='mb-2'>Franchisee reports are generated for one franchisee at a time. Please select a single franchisee.</p>
    <app-checkbox
      label='Include deleted users in the closer report'
      [defaultValue]='includeDeleted'
      (Change)='includeDeleted = $event'></app-checkbox>
  </div>
  <app-table (rowSelected)='onRowSelection($event)' [columns]='tableColumns' [dataSourceParams]='tableDatasourceParams'
             [dataSource]='tableDataSource'
             [enableSingleSelection]='singleSelection'
             [filterGroups]='tableFilterGroups' [preselectedIdentifier]="'account_id'"
             [preselected]='preselected' [selectable]='true'></app-table>
</div>